import React from 'react'
import * as styled from './AdminDivider.styled'

const AdminDivider: React.SFC = () => {
  return <styled.Divider>A d m i n</styled.Divider>
}

export default AdminDivider